import {styles} from "../../stylesheets/simulateurs.css";
import ButtonYesno from "../buttons/button.yesno";
import React from "react";
import {ToolTipPerso} from "../selects/tooltip_perso";
import TextfieldNumber from "../textfields/textfield.number";
import BadgeNouveau from "../texts/BadgeNouveau";

// example of component use:
//      <PrimoAccedant
//          handleChange={handleChange}
//          setPrimoAccedant={setPrimoAccedant}
//          primoAccedant={primoAccedant}
//          setMontantPrimoAccedant={setMontantPrimoAccedant}
//          maxPrimo={montantVente}
//      />

const PrimoAccedant = (props) => {

  return (
    <>
      <div className="cardRow">
        <div style={styles.cardElemVerticalyCenter}>Parmi le ou les acquéreur(s), y a-t-il un « primo-accédant » ?
          <ToolTipPerso
            title={
              "Le bien acquis constitue pour l’acquéreur une première propriété au sens du I de l’article L. 31-10-3 du code de la construction et de l’habitation et qu’il est destiné à l’usage de sa résidence principale."
            }
          />
          <BadgeNouveau cliquable={false}/>
        </div>
        <div>
          <ButtonYesno handleChange={props.handleChange} setter={props.setPrimoAccedant} reduxKey={"primo_accedant"} fieldUndefined={false} defaultValue={0} />
        </div>
      </div>
      {parseInt(props.primoAccedant) === 1 ? (
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Quel est le montant du prix de vente pris en charge par le(s) primo-accédant(s) ?
            <ToolTipPerso
              title={"Sans sa part des meubles.\n \n S'agissant des couples, la condition de première propriété s'apprécie de la façon suivante. " +
                "Dans le cadre d'une acquisition en indivision, chaque indivisaire a une quote-part des droits sur le bien (Code civil, art. 815-3). " +
                "Ainsi, l'absence de hausse temporaire de droits de mutation à titre onéreux (DMTO), prévue au B du II de l'article 116 de la loi de finances pour 2025 bénéficie à chaque acquéreur indivisaire répondant personnellement à la qualification de primoaccédant à hauteur de sa quote-part. \n" +
                "Cette règle s'applique aux concubins, personnes liées par un pacte civil de solidarité ainsi qu'aux époux mariés sous un régime de séparation de biens. " +
                "En revanche, en présence d'acquisition par des couples mariés sous le régime de la communauté réduite aux acquêts ou de la communauté universelle, les deux membres du couple doivent répondre à la qualification de primo-accédant afin que la hausse temporaire de DMTO ne soit pas appliquée. \n" +
                "Toutefois, en présence d'une acquisition faite par un seul des époux mariés sous un régime communautaire, la condition de première propriété ne sera requise que pour lui seul, si l'acquisition est faite sur ses fonds propres, remploi ou subrogation de bien propre en respectant la double déclaration dans l'acte."
              }
            />
          </div>
          <TextfieldNumber
            handleChange={props.handleChange}
            type={"number"}
            placeholder={"Indiquer le montant"}
            setter={props.setMontantPrimoAccedant}
            reduxKey={"montant_primo_accedant"}
            max={props.maxPrimo}   // ← active le blocage
          />
        </div>
      ) : null}
    </>
  );
};

export default PrimoAccedant;
